import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Row,
  Col,
  Label,
  Card,
  CardBody,
} from "reactstrap";

import { updateBatchApi } from "../../api/apiUrlConst";
import { toast } from "react-toastify";

interface Props {
  isOpen: boolean;
  toggle: () => void;
  batch: any;
  reloadBatches: () => void;
}

const EditBatchModal: React.FC<Props> = ({
  isOpen,
  toggle,
  batch,
  reloadBatches,
}) => {
  const [form, setForm] = useState<any>({
    batchName: "",
    course1Name: "",
    course1Trainer: "",
    b1StartDate: "",
    b1EndDate: "",
    batch1Status: "NotStarted",
    course2Name: "",
  });

 useEffect(() => {
  if (batch) {
      setForm(batch);
  }
}, [batch]);

  const handleChange = (e: any) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

const handleUpdate = async () => {
  try {

    const payload = {
      batchName: form.batchName,
      course1Name: form.course1Name,
      course1Trainer: form.course1Trainer,
     b1StartDate: form.b1StartDate ? new Date(form.b1StartDate).toISOString() : null,
b1EndDate: form.b1EndDate ? new Date(form.b1EndDate).toISOString() : null,
      batch1Status: String(form.batch1Status),
      course2Name: form.course2Name,

    };

    await updateBatchApi(batch.id, payload);

    reloadBatches();
    toggle();

  } catch (error:any) {
  toast.error(error.response?.data || "Update failed");
}
};

  return (
<Modal isOpen={isOpen} toggle={toggle} size="lg" centered>

  {/* Header */}
  <ModalHeader
    toggle={toggle}
    style={{
      background: "linear-gradient(90deg,#374151,#093d92)",
      color: "#fff",
      borderBottom: "none"
    }}
  >
    ✏ Edit Batch
  </ModalHeader>

  <ModalBody style={{ background: "#f4f6fb" }}>

    {/* Batch Name */}
    <Card className="border-0 shadow-sm mb-4">
      <CardBody>

        <Label className="fw-semibold">Batch Name</Label>

        <Input
          name="batchName"
          value={form.batchName}
          onChange={handleChange}
          className="rounded-pill shadow-sm"
        />

      </CardBody>
    </Card>

    {/* Course 1 */}
    <Card className="border-0 shadow-sm mb-4">
      <CardBody>

        <h6 className="fw-bold text-primary mb-3">
          📘 Course  Details
        </h6>

        <Row className="mb-3">

          <Col md="4">
            <Label>Course Name</Label>

             <Input
              type="select"
              name="course1Name"
              value={form.course1Name}
              onChange={handleChange}
              className="rounded-pill shadow-sm"
            >
              <option value="">Select Course</option>
            
              {/* Programming */}
               
              
              <option>Artificial Intelligence</option>
              <option>Data Science</option>
              <option>Machine Learning</option>
              <option>Python Programming</option>
              <option>C#</option>
              <option>C++</option>
              <option>Java</option>
             
            
              {/* CAD Customization */}
    
      <option>C++ & Creo Toolkit</option>
      <option>C++ & CATIA CAA</option>
      <option>C#.Net & Solidworks API</option>
      <option>C#.Net & Nx Customization</option>
      <option> C#.Net & Autodesk Inventor API</option>
      <option>C#.Net & AutoCAD API</option>
      <option>C#.Net & Solid Edge API</option>
      <option>C#.Net & Revit API</option>
      <option>Python & CATIA CAA</option>
      <option>Python & Nx Customization</option>
              <option>NX Customization</option>
              <option>SolidWorks API</option>
              <option>CATIA CAA</option>
              <option>Creo Toolkit</option>
              <option>Revit API</option>
              <option>AutoCAD API</option>
              <option>Solid Edge API</option>
              <option>Autodesk Inventor API</option>
            
              {/* PLM */}
              <option>Windchill</option>
              <option>Teamcenter</option>
              <option>Java & Windchill</option>
              <option>C++ & Team center</option>
            </Input>
          </Col>

          <Col md="4">
            <Label>Trainer</Label>

            <Input
              name="course1Trainer"
              value={form.course1Trainer}
              onChange={handleChange}
              className="rounded-pill shadow-sm"
            />
          </Col>

          <Col md="4">
            <Label>Course Name</Label>

             <Input
              type="select"
              name="course2Name"
              value={form.course2Name}
              onChange={handleChange}
              className="rounded-pill shadow-sm"
            >
              <option value="">Select Timing</option>
   <option>7 AM - 8 AM</option>
  <option>7 PM - 8 PM</option>
  <option>8 PM - 9PM</option>
  <option>9 PM - 10 PM</option>
            </Input>
          </Col>

        </Row>

        <Row>

          <Col md="4">
            <Label>Start Date</Label>

            <Input
              type="date"
              name="b1StartDate"
              value={form.b1StartDate?.substring(0, 10)}
              onChange={handleChange}
              className="rounded-pill shadow-sm"
            />
          </Col>

          <Col md="4">
            <Label>End Date</Label>

            <Input
              type="date"
              name="b1EndDate"
              value={form.b1EndDate?.substring(0, 10)}
              onChange={handleChange}
              className="rounded-pill shadow-sm"
            />
          </Col>

          <Col md="4">
            <Label>Status</Label>

         <Input
  type="select"
  name="batch1Status"
  value={form.batch1Status}
  onChange={handleChange}
  className="rounded-pill shadow-sm"
>
   <option value="NotStarted">Not Started</option>
            <option value="Upcoming">Upcoming</option>
            <option value="Ongoing">Ongoing</option>
            <option value="Completed">Completed</option>
</Input>
          </Col>

        </Row>

      </CardBody>
    </Card>


  </ModalBody>

  {/* Footer */}
  <ModalFooter style={{ borderTop: "none" }}>

    <Button
      style={{
        background: "linear-gradient(90deg,#374151,#093d92)",
        border: "none",
        borderRadius: "25px",
        padding: "8px 20px"
      }}
      onClick={handleUpdate}
    >
      Update Batch
    </Button>

    <Button
      color="light"
      className="rounded-pill px-4"
      onClick={toggle}
    >
      Cancel
    </Button>

  </ModalFooter>

</Modal>
  );
};

export default EditBatchModal;